
import React from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import Toolbar from "../../../components/toolbar/Toolbar";
import { Column } from 'primereact/column';
import { routes } from '../../../constants';
import { Page } from "../../../components/page/Page";
import { VehicleTypeList } from "./VehicleTypeList";
import { actions } from '../vehicleType.actions'
import { AppService, COMPANY_CHANGE_EVENT_NAME, BUSINESS_UNIT_CHANGE_EVENT_NAME } from "../../../services/app.service";

import * as utils from '../../../utils';

const mapStateToProps = state => {
  return {
    columns: state.crudVehicleTypeState.columns,
    records: state.crudVehicleTypeState.records,
    first: state.crudVehicleTypeState.index,
    rows: state.crudVehicleTypeState.max,
    totalRecords: state.crudVehicleTypeState.count,
    sortField: state.crudVehicleTypeState.sortField,
    order: state.crudVehicleTypeState.sortOrder
  }
}
const mapDispatchToProps = dispatch => {
  return {
    paginate: paginationParams => dispatch(actions.paginate(paginationParams)),
    sortOrder: sortParams => dispatch(actions.sortOrder(sortParams)),
    applyFilter: filterParams => {
      dispatch(actions.setType(null));
      dispatch(actions.applyFilter(filterParams))
    },
    load: () => dispatch(actions.load())
  }
}


class VehicleTypeListPageContainer extends React.Component {

  newHandler = () => {
    this.props.history.push(`${routes.PATH_VEHICLE_TYPE}/novo`)
  }


  componentDidMount() {
    this.props.load();
    AppService.on(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.on(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
  }
  componentWillUnmount() {
    AppService.off(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.off(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
  }

  onReceiveAppNotifications = (eventName, params) => {
    if (eventName === COMPANY_CHANGE_EVENT_NAME || eventName === BUSINESS_UNIT_CHANGE_EVENT_NAME) {
      this.props.load();
    }
  }


  onPage = (e) => {
    this.props.paginate({
      max: e.rows,
      index: e.first
    })
  }
  onSort = (e) => {
    console.log('sorting', e);
    this.props.sortOrder({
      sortOrder: e.sortOrder,
      sortField: e.sortField
    })


  }
  onFilter = (e) => {
    console.log(e);
    const filters = [];
    const keys = Object.keys(e.filters) || [];
    keys.forEach(key => {
      if (key == "oid") {
        filters.push({
          campo: key,
          valor: parseInt(e.filters[key].value),
          tipoFiltro: 'IGUAL_A'
        })
      } else {
        filters.push({
          campo: key,
          valor: e.filters[key].value,
          tipoFiltro: 'CONTEM'

        })
      }
    })
    console.log(filters);
    this.props.applyFilter(filters)
  }

  render() {
    const header = (
      <div>
        <h1>Tipos de veículo</h1>
        <div>
          <Toolbar onNew={this.newHandler} newButtonStyle='highlighted'>
          </Toolbar >
        </div>
      </div>
    );
    const oidTemplate = (rowData, column) => {
      return (
        <div className="id-link"><Link to={`${routes.PATH_VEHICLE_TYPE}/${rowData.oid}`}>{rowData.oid}</Link></div>
      )
    }

    const valuePricePerKMTemplate = (rowData, column) => {
      return (
        <span style={{ display: "inline-block", width: "100%", textAlign: "center" }}>{utils.formatNumber(rowData.pricePerKM)}</span>
      )
    }

    const valuePricePerKiloTemplate = (rowData, column) => {
      return (
        <span style={{ display: "inline-block", width: "100%", textAlign: "center" }}>{utils.formatNumber(rowData.pricePerKilo)}</span>
      )
    }

    const columns = this.props.columns.map(col => {
      if (col.field === 'oid') {
        return (<Column {...col} key={col.field} body={oidTemplate} style={{ textAlign: "center" }}/>);
      }
      // if (col.field === 'code') {
      //   return (<Column {...col} key={col.field} style={{ textAlign: "center" }}/>);
      // }
      // if (col.field === 'averageSpeed') {
      //   return (<Column {...col} key={col.field} style={{ textAlign: "center" }}/>);
      // }
      if (col.field === 'pricePerKM'){
        return (<Column {...col} key={col.field} body={valuePricePerKMTemplate} />)
      }
      if (col.field === 'pricePerKilo' ){
        return (<Column {...col} key={col.field} body={valuePricePerKiloTemplate} />)
      }

      return (<Column {...col} key={col.field}  style={{ textAlign: "center" }}/>)
    })

    const content = <VehicleTypeList  {...this.props} onFilter={this.onFilter} onPage={this.onPage} onSort={this.onSort} columns={columns} />;
    return <Page header={header} content={content} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleTypeListPageContainer);
